import type { ChangeEvent } from 'react';

import classNames from 'classnames';

import { FormToggle } from '@spotify-internal/encore-web';

import styles from './SkipInactiveToggle.module.css';

type SkipInactiveToggleProps = {
  checked: boolean;
  className?: string;
  onChange: (checked: boolean) => void;
};

export const SkipInactiveToggle = ({
  checked,
  className,
  onChange,
}: SkipInactiveToggleProps) => (
  <FormToggle
    size="small"
    checked={checked}
    labelClassName={classNames(styles.root, className)}
    onChange={(event: ChangeEvent<HTMLInputElement>) =>
      onChange(event.currentTarget.checked)
    }
    data-track-id="switch.skip-inactive"
    data-track-action="update"
    data-track-data-enabled={!checked}
  >
    Skip inactive
  </FormToggle>
);
